import React, { forwardRef, useCallback, useContext, useEffect, useImperativeHandle } from "react";
import { useRef } from "react";
import { useState } from "react";
import { BasicInformationData } from "../../data/BasicInformation.Data";
import BasicDetailContext from "../../utils/BasicDetailContext";
import handleFieldChange from "./utils/handleFieldChange";
import { useStoreBase64ImageMutation } from "../../../../app/services/common/commonServiceApi";
import ToastService from "../../../../services/toastService/ToastService";
import { useLazyGetAllDropDownForEventManagementQuery } from "../../../../app/services/EventManagement/ViewEditEvent/ViewEditEventApi";
import { setAllDropDownFieldsBatch } from "../../../../utils/FormFields/FieldsSetting/SetFieldSetting";
import { viewListDropDowns } from "../../utils/setDropdownFields";
import { ZoomAccountFormData } from "../AvailabilitySchedule/data/ZoomAccountForm.Data";
import FormCreator from "../../../../components/forms/FormCreator";
import DataLoader from "../../../../components/FinalMolGrid/ui/dataLoader/DataLoader";

const BasicInformation = forwardRef((props, ref) => {
  const basicInformationRef = useRef();
  const [basicInformationForm, setBasicInformationForm] = useState(BasicInformationData);
  const { entryType, setEntryType } = useContext(BasicDetailContext);

  const [geEventListDropDown, { isLoading: viewEventListDropDownIsLoading, data: viewEventListDropDownData, isSuccess: viewEvenetListDropDownIsSuccess }] = useLazyGetAllDropDownForEventManagementQuery();


  useEffect(() => {
    if (!viewEventListDropDownIsLoading && viewEvenetListDropDownIsSuccess && viewEventListDropDownData) {
      // Updates dropdown fields in the form based on the fetched data
      setAllDropDownFieldsBatch(BasicInformationData, viewListDropDowns, viewEventListDropDownData);
      setAllDropDownFieldsBatch(ZoomAccountFormData, viewListDropDowns, viewEventListDropDownData);
    }
  }, [viewEventListDropDownIsLoading, viewEvenetListDropDownIsSuccess, viewEventListDropDownData]);

  useEffect(() => {
    geEventListDropDown();
  }, []);

  // Expose method `getFormData` to parent components to retrieve form data from `FormCreator`
  useImperativeHandle(ref, () => ({
    getFormData: () => {
      if (ref?.current) {
        const basicInformationFormData = basicInformationRef.current.getFormData();
        return basicInformationFormData;
      }
      return null;
    }
  }))


  const handleImageUpload = useCallback((fileDetails, storagePath) => {
    const request = {
      fileName: fileDetails?.fileName,
      fileStr: fileDetails?.base64Data,
      storagePath: storagePath,
    };
    props?.imageUpload(request);
  }, [props?.imageUpload]);

  // Memoized handler for optimized field changes
  const memoizedHandleFieldChange = useCallback(
    (dataFieldName, updateFormData) => {
      if (dataFieldName === "membershipType") {
        return setEntryType(updateFormData?.membershipType?.value);
      } else if (dataFieldName === "displayEventImage") {
        return handleImageUpload(updateFormData?.displayEventImage, "EventImage");
      }
      else if (dataFieldName === "displaySpeakerImage") {
        return handleImageUpload(updateFormData?.displaySpeakerImage, "SpeakerImage");
      }
      else {
        return handleFieldChange(dataFieldName, updateFormData, BasicInformationData);
      }
    },
    [entryType]
  );

  return (
    <div className="row">

      {viewEventListDropDownIsLoading ? <DataLoader /> : <FormCreator
        config={basicInformationForm}
        ref={basicInformationRef}
        key={false}
        onColumnChange={memoizedHandleFieldChange}
      />
      }
    </div >
  );
})
export default BasicInformation;
